import _ from 'lodash';
import { filterOption } from '../../bsApp';

const bsFilterFunc = {
  initFilterData: (groupIndexs, value) => {
    const newFilterData = {};
    _.forEach(groupIndexs, (itemIndex) => {
      _.forEach(filterOption[itemIndex], (item) => {
        newFilterData[item] = Boolean(value);
      });
    });
    return newFilterData;
  },
  getKeys: function (groupIndexs) {
    const result = [];
    _.forEach(groupIndexs, (indexItem) => {
      result.push(...filterOption[indexItem]);
    });
    return result;
  },
  getStatusKeys: function () {
    return this.getKeys([0]);
  },
  getRemarksKeys: function () {
    return this.getKeys([1, 2, 3]);
  },
  setExtentFilter: function ({ allData, keyList, value }) {
    const result = { ...allData };
    _.forEach(keyList, (item) => {
      result[item] = Boolean(value);
    });
    return result;
  },
  setFilter: function ({ keyList, groupIndexs, defaultValue, value }) {
    const result = this.initFilterData(groupIndexs, defaultValue);
    _.forEach(keyList, (item) => {
      result[item] = Boolean(value);
    });
    return result;
  },
  isSelectAllStatus: function ({ allData }) {
    const keys = this.getStatusKeys();
    return allData
      ? _.filter(keys, (item) => {
          return allData[item];
        }).length === keys.length
      : false;
  },
  isSelectAllRemarks: function ({ allData }) {
    const keys = this.getRemarksKeys();
    if (!allData) return false;
    const temp = _.filter(keys, (item) => {
      return allData[item];
    });
    return temp.length === keys.length || temp.length === 0;
  },
  isSelectAll: function ({ allData }) {
    return this.isSelectAllStatus({ allData }) && this.isSelectAllRemarks({ allData });
  },
  setDefaultFilter: function () {
    return { ...this.initFilterData([0], true), ...this.initFilterData([1, 2, 3], false) };
  },
  clickStatus: function ({ allData, keys }) {
    return {
      ...allData,
      ...this.setFilter({ keyList: keys, value: true, defaultValue: false, groupIndexs: [0] }),
      ...this.initFilterData([1, 2, 3], false),
    };
  },
  clickRemarks: function ({ allData, keys }) {
    return {
      ...allData,
      ...this.setFilter({
        keyList: keys,
        value: true,
        defaultValue: false,
        groupIndexs: [1, 2, 3],
      }),
      ...this.initFilterData([0], true),
    };
  },
  clickFilter: function ({ allData, keys }) {
    if (Array.isArray(keys)) {
      const key = keys[0];
      if (this.getStatusKeys().includes(key)) {
        return this.clickStatus({ allData, keys });
      } else {
        return this.clickRemarks({ allData, keys });
      }
    } else {
      const newKeys = [keys];
      if (this.getStatusKeys().includes(keys)) {
        return this.clickStatus({ allData, keys: newKeys });
      } else {
        return this.clickRemarks({ allData, keys: newKeys });
      }
    }
  },
  getAllTrueValue: function (allData) {
    const result = [];
    const statusList = [];
    if (!allData) return null;

    this.getRemarksKeys().forEach((item) => {
      if (allData[item]) {
        result.push({ key: item, value: 1 });
      }
    });
    this.getStatusKeys().forEach((item) => {
      if (allData[item]) {
        statusList.push(item);
      }
    });
    result.push({
      key: 'status',
      value: statusList.join(','),
    });
    // }
    return result;
  },
};

export { bsFilterFunc };
